// api VM
import { REACT_APP_TRAFFIC_MANAGER_ORIGIN } from './envs';

// proxy VideoManager NextJs endpoints
export const VM_API_TM_V3_PROXY_URI = '/api/trafficmanager/api/v3';
export const GRAPHQL_URI = '/api/graphql';
export const REQUEST_WATCH_CONFIG_URI = '/api/watch/config';

const apiPart = `${REACT_APP_TRAFFIC_MANAGER_ORIGIN}/trafficmanager/api`;

export const SEARCH_AUTOCOMPLETE_ENDPOINT_URL = `${apiPart}/videos/search/autocomplete`;
export const SEARCH_ENDPOINT_URL = `${apiPart}/videos/search`;
export const SEARCH_AI_ENDPOINT_URL = `${apiPart}/genai/videos/search`;
export const DEEP_SEARCH_ENDPOINT_URL = `${apiPart}/videos/deepSearch`;
export const PLAYLIST_ENDPOINT_URL = `${apiPart}/v2/player/playlist`;
export const MULTI_PLAYLIST_ENDPOINT_URL = `${apiPart}/v2/player/multiplaylists`;
export const TRANSCRIPT_ENDPOINT_URL = `${apiPart}/videos/transcript`;
export const SLIDES_ENDPOINT_URL = `${apiPart}/videos/slides`;
export const REFRESH_SIGNED_URLS_ENDPOINT_URL = `${apiPart}/playback/authRefresh`;

export const PATH_REGEXP = /trafficmanager\/api\/(v[0-9]+\/)?/;

export const TOKEN_EXPIRED_MESSAGE = 'Token expired';
export const NO_PERMISSION_MESSAGE = 'No permission';

export const PLAYLIST_REQUEST_TIMEOUT = 10 * 1000;
export const SEARCH_GEN_AI_REQUEST_TIMEOUT = 120 * 1000;
export const REJECT_REQUEST_BY_USER_CODE = 20;
